import {
    GenericItemsUtils,
    Grid,
    IGetAllParams,
    GenericItemsForm,
    BaseGenericItemsStore,
    MuiDataGrid,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";
import {IPartner} from "@leap4/entities-discrepancy-common"
import {baseBackendRoute} from "../../../config/generals";
import {urlService} from "../../routing/urlsService"
import * as React from "react";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";
type GridColDef = MuiDataGrid.GridColDef;

const fields = {
    name: 1,
    side: 1,
    created: 1,
    updated: 1,
    isActive: 1,
}

const getParams: IGetAllParams = {
    fields,
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<IPartner & { _id: string, isActive: boolean }>

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;


function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: baseBackendRoute + "/partners",
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editPartner(id)},
        isActive: {},
        updated: {},
        created: {}
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

}



const PartnersModule = (props:PropsFromRedux) => {
    setStoreAndColumns();

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.partners(),
                text: "Partners Dashboard",
                icon: <TocIcon />
            }}
            getAllParams={getParams}
            createButton={{
                to: urlService.createPartner(),
                text: "create Partner ".toUpperCase()
            }}/>
    );
};


export default connector(PartnersModule);